<template>
  <v-col class="test_purple">
    <v-list dense>
      <v-list-item ripple>
        <v-list-item-content>
          <v-list-item-title>
            <v-container fluid fill-height class="test_green pl-0">
              <v-row no-gutters justify="space-between">
                <v-col cols="auto">
                  <span class="text" v-text="$t('checkout.subtotal')" />
                </v-col>
                <v-col cols="auto">
                  <span
                    class="price"
                    v-text="
                      $appFormatters.formatMoney(
                        $store.getters.cartDetails.subTotal
                      )
                    "
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="
          $store.getters.deliveryMethod === 'delivery-service' &&
          $store.getters.guestAddress
        "
        ripple
      >
        <v-list-item-content>
          <v-list-item-title>
            <v-container fluid fill-height class="test_green pl-0">
              <v-row no-gutters justify="space-between">
                <v-col cols="auto">
                  <span class="text" v-text="$t('general.delivery')" />
                </v-col>
                <v-col cols="auto">
                  <span
                    v-if="$store.getters.cartDetails.deliveryPrice !== 0"
                    class="price"
                    v-text="
                      $appFormatters.formatMoney(
                        $store.getters.cartDetails.deliveryPrice
                      )
                    "
                  />
                  <span
                    v-if="$store.getters.cartDetails.deliveryPrice === 0"
                    class="price"
                    style="color: green; font-weight: bold"
                    v-text="$t('general.free')"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        v-if="
          $store.getters.storeInfo.configs.extraBagCost > 0 && !isTableOrder
        "
        ripple
      >
        <v-list-item-content>
          <v-list-item-title>
            <v-container fluid fill-height class="test_green pl-0">
              <v-row no-gutters justify="space-between">
                <v-col cols="auto">
                  <span
                    class="text"
                    v-text="$t('checkout.checkout_extra_bag_cost')"
                  />
                </v-col>
                <v-col cols="auto">
                  <span
                    class="price"
                    v-text="
                      $appFormatters.formatMoney(
                        $store.getters.storeInfo.configs.extraBagCost
                      )
                    "
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-list-item-title>

          <v-list-item-subtitle
            style="white-space: initial"
            class="px-3 pl-0"
            v-text="$t('checkout.checkout_extra_bag_cost_description')"
          />
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        v-if="
          $store.getters.cartDetails.serviceFee > 0 &&
          $store.getters.cartDetails.serviceFee !== null
        "
        ripple
      >
        <v-list-item-content>
          <v-list-item-title>
            <v-container fluid fill-height class="test_green pl-0">
              <v-row no-gutters justify="space-between">
                <v-col cols="auto">
                  <span class="text" v-text="$t('checkout.serviceFee')" />
                </v-col>
                <v-col cols="auto">
                  <span
                    class="price"
                    v-text="
                      $appFormatters.formatMoney(
                        $store.getters.cartDetails.serviceFee
                      )
                    "
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="mt-5"></v-divider>

      <v-list-item v-if="discountAmount > 0" ripple>
        <v-list-item-content>
          <v-list-item-title>
            <v-container fluid fill-height class="test_green pl-0">
              <v-row no-gutters justify="space-between">
                <v-col cols="auto">
                  <span class="text" v-text="$t('offers.discount')" />
                </v-col>
                <v-col cols="auto">
                  <span
                    class="price"
                    v-text="'- ' + $appFormatters.formatMoney(discountAmount)"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="credits > 0 && $store.getters.user && $store.getters.useCredit"
        ripple
      >
        <v-list-item-content>
          <v-list-item-title>
            <v-container fluid fill-height class="test_green pl-0">
              <v-row no-gutters justify="space-between">
                <v-col cols="auto">
                  <span class="text" v-text="$t('customerProfile.credits')" />
                </v-col>
                <v-col cols="auto">
                  <span
                    class="price"
                    v-text="'- ' + $appFormatters.formatMoney(credits)"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item ripple>
        <v-list-item-content>
          <v-list-item-title>
            <v-container fluid fill-height class="test_green pl-0">
              <v-row no-gutters justify="space-between">
                <v-col cols="auto">
                  <span class="text" v-text="$t('checkout.total')" />
                </v-col>
                <v-col cols="auto">
                  <span
                    class="price"
                    v-text="$appFormatters.formatMoney($store.getters.total)"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-col>
</template>

<script>
export default {
  name: "OrderDetails",
  props: {
    isTableOrder: {
      type: Boolean,
      required: false,
    },
  },
  data: () => ({
    discountAmount: 0,
    credits: 0,
    total: 0,
  }),
  watch: {
    "$store.getters.checkoutValidation.promoCode.status": function () {
      this.calculateAmounts();
    },
    "$store.getters.deliveryMethod": function () {
      this.calculateAmounts();
    },
    "$store.getters.deliveryPrice": function () {
      this.calculateAmounts();
    },
    "$store.getters.cartDetails": function () {
      this.calculateAmounts();
    },
  },

  mounted() {
    const self = this;
    self.calculateAmounts();
  },
  methods: {
    calculateAmounts: function () {
      const self = this;
      self.discountAmount = self.$store.getters.cartDetails.offer;
      self.credits = self.$store.getters.cartDetails.credits;

      // const bagCost = this.isTableOrder
      //   ? "0.00"
      //   : self.$store.getters.storeInfo.configs.extraBagCost;

      let totalLocal = parseFloat(self.$store.getters.cartDetails.cartTotal);

      // if (
      //   self.$store.getters.deliveryMethod === "delivery-service" &&
      //   self.$store.getters.deliveryPrice
      // ) {
      //   totalLocal += parseFloat(self.$store.getters.deliveryPrice);
      // }
      this.$store.dispatch("checkout/setTotal", totalLocal);
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  font-size: 1.3rem;
}

.price {
  font-size: 1.3rem;
  text-transform: none;
}
@media only screen and (min-width: 320px) and (max-width: 479px) {
  .price {
    font-size: 1rem;
  }
}
</style>
